export default __webpack_public_path__ + "static/media/1888.86ce6a06.png";